import { ReactElement } from "react";
import styled, { css } from "styled-components";
import { shade800 } from "../../../styles/tokens";

// TEXT

// STYLES
export const Wrapper = styled.div<{
  $hasAction: boolean;
  $hasHandle?: boolean;
  $hasDivider?: boolean;
}>`
  width: 100%;
  display: flex;
  padding: 0.5rem;
  text-align: center;
  min-height: 3.25rem;
  align-items: flex-start;
  justify-content: space-between;

  border-bottom: ${({ $hasDivider = true }) =>
    $hasDivider ? `1px solid ${shade800}` : "none"};

  ${({ $hasAction }) =>
    $hasAction &&
    css`
      min-height: unset;
      align-items: center;
    `}

  ${({ $hasAction, $hasHandle }) =>
    // The Handle component uses padding-bottom: 10px by default. If the Head component
    // contains actions, the padding should be reduced to 6px. Since detecting actions inside
    // Head from within Handle adds unnecessary complexity, using a negative margin
    // on Head appears to be a practical workaround.
    $hasAction &&
    $hasHandle &&
    css`
      margin: -0.25rem;
      padding: 0 0.5rem 0.5rem 0.5rem;
    `}
`;

export const BottomSheetMetaHead = styled.div`
  padding: 0.5rem 1.5rem 1rem;
  border-bottom: 1px solid ${shade800};
`;

export const Action = styled.div`
  display: flex;
  min-width: 3rem;
  align-items: center;
`;

export const Title = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 0.0625rem;
`;

export const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;
`;

// DATA

// TYPES
export type Props = {
  title: string;
  subtitle?: string;
  hasHandle?: boolean;
  /**
   * Whether to show the divider line between the head and the sheet body.
   * @default true
   */
  hasDivider?: boolean;
  Back?: ReactElement;
  Close?: ReactElement;
  onBack?: () => void;
  onClose?: () => void;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
